export default "__VITE_ASSET__ObMLNbes__"